import { FC } from "react";
import { Control, FieldErrors } from "react-hook-form";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";
import CustomDatePicker from "app/components/common/inputs/CustomDatePicker";

type FieldType = "text" | "email" | "date";

interface FieldConfig {
  label: string;
  name: string;
  type: FieldType;
  placeholder?: string;
  required?: boolean;
  rules?: any;
  className?: string;
  validateAge?: boolean;
  maxDate?: boolean;
}

interface Props {
  fields: FieldConfig[];
  control: Control<any>;
  errors: FieldErrors;
}

const DynamicFormOne: FC<Props> = ({ fields, control, errors }) => {
  const groupedFields: FieldConfig[][] = [];

  // Loop through the fields and group them in pairs
  for (let i = 0; i < fields.length; i += 2) {
    groupedFields.push(fields.slice(i, i + 2));
  }

  return (
    <>
      {groupedFields.map((group, index) => (
        <FormGroup key={index}>
          {group.map((field) => {
            const error = field.name
              .split(".")
              .reduce((acc: any, key: string) => acc?.[key], errors);

            if (field.type === "date") {
              return (
                <CustomDatePicker
                  key={field.name}
                  name={field.name}
                  control={control}
                  label={field.label}
                  placeholder={field.placeholder}
                  rules={field.rules}
                  className={field.className}
                  validateAge={field.validateAge}
                  {...(field.maxDate ? { maxDate: new Date() } : {})}
                />
              );
            }

            return (
              <InputField
                key={field.name}
                label={field.label}
                name={field.name}
                control={control}
                type={field.type}
                required={field.required}
                placeholder={field.placeholder}
                error={error?.message}
                className={field.className}
                rules={field.rules}
              />
            );
          })}
        </FormGroup>
      ))}
    </>
  );
};

export default DynamicFormOne;
